import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import CloseSvg from "src/components/svg/CloseSvg";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import styles from './LabelledCheck.module.css';

//#region [Props]
type DeletableLabelledCheckProps = {
  className?: string;
  selected?: boolean;
  selectionCallback: (isSelected: boolean) => void;
  value: string | number;
  label?: string;
  /* Filmweb */
  fwVariant?: "outlineGradient1";
  dkVariant?: "darkOutline";
  borderStyle?: "round" | "square" | "roundedSquare"; // roundedSquare is default
};
//#endregion

//#region [Component]
export default function DeletableLabelledCheck(t0) {
  const $ = _c(27);
  const {
    className,
    selected: t1,
    selectionCallback,
    value,
    label,
    fwVariant,
    dkVariant,
    borderStyle
  } = t0;
  const selected = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== borderStyle || $[1] !== className || $[2] !== dkVariant || $[3] !== fwVariant || $[4] !== selected || $[5] !== selectionCallback || $[6] !== value) {
    const themeStyles = getThemeStyles(styles, {
      [styles.selected]: selected,
      "selected": selected,
      [styles.OutlineGradient1]: fwVariant === "outlineGradient1",
      [styles.DarkOutlineVariant]: dkVariant === "darkOutline",
      [styles.square]: borderStyle === "square",
      [styles.round]: borderStyle === "round"
    });
    t3 = className;
    let t5;
    if ($[10] !== selected || $[11] !== selectionCallback) {
      t5 = () => selectionCallback(!selected);
      $[10] = selected;
      $[11] = selectionCallback;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    if ($[13] !== selected || $[14] !== t5 || $[15] !== value) {
      t4 = <input className={styles.SCheckInput} type="checkbox" checked={selected} onChange={t5} value={value} />;
      $[13] = selected;
      $[14] = t5;
      $[15] = value;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t2 = classNames(styles.SLabelSpan, themeStyles);
    $[0] = borderStyle;
    $[1] = className;
    $[2] = dkVariant;
    $[3] = fwVariant;
    $[4] = selected;
    $[5] = selectionCallback;
    $[6] = value;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[17] !== selected) {
    t5 = selected && <CloseSvg className={styles.SCheckMarkSvg} />;
    $[17] = selected;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = label ?? value;
  let t7;
  if ($[19] !== t2 || $[20] !== t5 || $[21] !== t6) {
    t7 = <span className={t2}>{t5} {t6}</span>;
    $[19] = t2;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t3 || $[24] !== t4 || $[25] !== t7) {
    t8 = <label className={t3}>{t4}{t7}</label>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
//#endregion

//#region [Styles]
//#endregion